import { useEffect, useState } from "react";
import api, { formatInr } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["pending", "confirmed", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/orders/${id}`, { status });
    toast.success("Order updated");
    load();
  };

  return (
    <div>
      <div className="overline">Operations</div>
      <h1 className="font-display text-4xl mt-2 mb-8">Orders ({orders.length})</h1>

      <div className="bg-white border border-[var(--fm-border)] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[var(--fm-sage)] text-left">
            <tr>
              <Th>Order</Th><Th>Customer</Th><Th>Total</Th><Th>Items</Th><Th>Status</Th><Th>Date</Th><Th></Th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-[var(--fm-border)] align-top">
                <Td className="font-mono-fm text-xs">{o.id.slice(0, 8)}</Td>
                <Td><div className="font-medium">{o.user_name}</div><div className="text-xs text-[var(--fm-text-3)]">{o.user_email}</div></Td>
                <Td className="font-mono-fm">{formatInr(o.total)}</Td>
                <Td>{o.items.length}</Td>
                <Td>
                  <select data-testid={`order-status-${o.id}`} value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} className="border border-[var(--fm-border)] px-2 py-1 text-xs bg-white">
                    {STATUSES.map((s) => <option key={s}>{s}</option>)}
                  </select>
                </Td>
                <Td className="text-xs text-[var(--fm-text-3)]">{new Date(o.created_at).toLocaleString("en-IN")}</Td>
                <Td><button onClick={() => setOpen(o)} className="text-xs text-[var(--fm-primary)] underline">View</button></Td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={7} className="p-10 text-center text-sm text-[var(--fm-text-2)]">No orders yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/50 z-50 grid place-items-center p-4" onClick={() => setOpen(null)}>
          <div className="bg-white max-w-2xl w-full p-8 border border-[var(--fm-border)]" onClick={(e) => e.stopPropagation()}>
            <div className="overline text-[var(--fm-accent)]">Order #{open.id.slice(0, 8)}</div>
            <div className="font-display text-2xl mt-1">{open.user_name}</div>
            <div className="text-sm text-[var(--fm-text-2)]">{open.user_email}</div>
            <div className="mt-6 space-y-2 text-sm">
              {open.items.map((it, idx) => (
                <div key={idx} className="flex justify-between"><span>{it.quantity} × {it.name}</span><span className="font-mono-fm">{formatInr(it.line_total)}</span></div>
              ))}
              <div className="border-t border-[var(--fm-border)] mt-3 pt-3 flex justify-between font-medium"><span>Total</span><span className="font-mono-fm">{formatInr(open.total)}</span></div>
            </div>
            <div className="mt-6 text-sm">
              <div className="overline mb-2">Shipping to</div>
              <div>{open.address.full_name}{open.address.clinic_name ? `, ${open.address.clinic_name}` : ""}</div>
              <div>{open.address.line1}{open.address.line2 ? `, ${open.address.line2}` : ""}</div>
              <div>{open.address.city}, {open.address.state} – {open.address.pincode}</div>
              <div>{open.address.phone}</div>
            </div>
            <button onClick={() => setOpen(null)} className="fm-btn-primary mt-6">Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

function Th({ children }) { return <th className="px-4 py-3 overline">{children}</th>; }
function Td({ children, className = "" }) { return <td className={`px-4 py-3 ${className}`}>{children}</td>; }
